export class ActionUtils {
  static open(url: string) {
    url = url?.startsWith('http') ? url : 'https://orbit-x-edu.us/' + url;

    // const matchedHost = 'https://orbit-x-edu.us/qiniu-resources/';
    // const toReplaceUrl = 'http://static.orbit-x-edu.com/';
    // if (url?.startsWith(matchedHost)) {
    //   url = url.replace(matchedHost, toReplaceUrl);
    // }

    window.open(url);
  }
}
